window.mosaicCardJs = window.mosaicCardJs || {
  isInitialized: false,
  hoverTimeoutId: null,
  hasMoreItems: true,
  resizeHandler: function () {
    const mosaicCards = [...document.querySelectorAll('.arjo-m-mosaic-card')];
    mosaicCards.forEach((card) => {
      var rect = card.getBoundingClientRect();
      if (window.arjoJs.isMobile()) {
        card.setAttribute('data-mobile', '');
      } else {
        card.removeAttribute('data-mobile');
      }

      if (rect.width < 500) {
        card.setAttribute('data-sm', '');
      } else {
        card.removeAttribute('data-sm');
      }

      if (rect.width < 380) {
        card.setAttribute('data-xs', '');
      } else {
        card.removeAttribute('data-xs');
      }

      const imageContainer = card.querySelector('.arjo-m-mosaic-card__image-container');
      if (imageContainer) {
        const image = imageContainer.querySelector('.arjo-a-picture');
        if (image) {
          const imagePosition =
            card.classList.contains('arjo-m-mosaic-card--round-image') || card.classList.contains('arjo-m-mosaic-card--presenter');
          if (imagePosition) {
            var imageContainerRect = imageContainer.getBoundingClientRect();
            var diameter = card.classList.contains('arjo-m-mosaic-card--full-banner')
              ? imageContainerRect.width
              : card.hasAttribute('data-mobile') || card.hasAttribute('data-sm') || card.classList.contains('arjo-m-mosaic-card--image-auto-height')
                ? Math.min(imageContainerRect.width, 440)
                : Math.min(imageContainerRect.width, imageContainerRect.height, 440);
            image.style.width = diameter + 'px';
            image.style.height = diameter + 'px';
          } else {
            image.style.removeProperty('width');
            image.style.removeProperty('height');
          }
          image.style.opacity = 1;
        }
      }
    });
  },
  loadMoreClickHandler: function (cardList) {
    const loadMoreButton = cardList.querySelector('.arjo-m-mosaic-card-list__load-more');
    const loadMoreLabel = loadMoreButton?.querySelector('.arjo-m-button-expander__label');

    if (!loadMoreLabel) return;

    const itemContainer = cardList.querySelector('.arjo-m-mosaic-card-list__items');
    if (!itemContainer) {
      return;
    }

    const loadMoreElement = itemContainer.querySelector('.arjo-m-mosaic-card-list__load-more-url');
    if (!loadMoreElement) {
      loadMoreLabel.dataset.inactive = "true"
      return;
    }

    const spinner = cardList.querySelector('.arjo-a-spinner');

    const loadMoreUrl = loadMoreElement.getAttribute('data-url');
    if (!loadMoreUrl) {
      return;
    }
    loadMoreElement.remove();
    loadMoreLabel.dataset.inactive = "true"

    if (spinner) {
      spinner.style.display = 'flex';
    }

    axios
      .get(loadMoreUrl)
      .then((response) => {
        if (!response.data) {
          return;
        }

        itemContainer.insertAdjacentHTML('beforeend', response.data);
        const hasMoreItems = itemContainer.querySelector('.arjo-m-mosaic-card-list__load-more-url');

        if (hasMoreItems) {
          this.hasMoreItems = true;
          loadMoreLabel.removeAttribute('data-inactive')
        } else {
          this.hasMoreItems = false;
          loadMoreButton.style.display = 'none';
        }
      })
      .catch(function (error) {
        console.log(error);
        loadMoreLabel.style.removeProperty('display');
        loadMoreLabel.dataset.inactive = "true"
      })
      .finally(function () {
        if (spinner) {
          spinner.style.removeProperty('display');
        }
      });
  },
  loadMoreOnHover: function (loadMoreButton, loadMoreLabel, cardList, hoverDelay) {
    if (!hoverDelay || !this.hasMoreItems) return;
    const spinner = cardList.querySelector('.arjo-a-spinner');

    loadMoreButton?.addEventListener('mouseenter', () => {
      spinner.style.display = 'block';
      loadMoreLabel.dataset.inactive = "true"

      this.hoverTimeoutId = setTimeout(() => {
        this.loadMoreClickHandler(cardList);
      }, +hoverDelay);
    });
  },
  spinnerOnHover: function (loadMoreButton, cardList, loadMoreLabel) {
    const spinner = cardList.querySelector('.arjo-a-spinner');

    if (!spinner) return;

    loadMoreButton.addEventListener('mouseleave', () => {
      if (this.hoverTimeoutId) {
        setTimeout(() => {
          window.clearTimeout(this.hoverTimeoutId);
          spinner.style.display = 'none';

          if (this.hasMoreItems) {
            loadMoreLabel.removeAttribute('data-inactive')
          }
        }, 50);
      }
    });
  },
  setupLoadMore: function () {
    const mosaicCardLists = [...document.querySelectorAll('.arjo-m-mosaic-card-list')];
    mosaicCardLists.forEach((cardList) => {
      const hoverDelay = cardList.dataset.hoverDelay;

      if (cardList.hasAttribute('data-auto-load-more')) {
        this.loadMoreClickHandler(cardList);
      }

      const buttonArea = cardList.querySelector('.arjo-m-mosaic-card-list__buttons');
      if (!buttonArea) {
        return;
      }

      const loadMoreButton = buttonArea.querySelector('.arjo-m-mosaic-card-list__load-more');
      if (!loadMoreButton) {
        return;
      }

      buttonArea.removeAttribute('data-hidden');

      loadMoreButton.addEventListener('click', () => this.loadMoreClickHandler(cardList));
      const loadMoreLabel = loadMoreButton?.querySelector('.arjo-m-button-expander__label');

      if (!loadMoreLabel) return;

      this.loadMoreOnHover(loadMoreButton, loadMoreLabel, cardList, hoverDelay);
      this.spinnerOnHover(loadMoreButton, cardList, loadMoreLabel);
    });
  },
  setupLinkForImage: function () {
    const mosaicCards = [...document.querySelectorAll('.arjo-m-mosaic-card')];

    mosaicCards.forEach((card) => {
      const imageContainer = card.querySelector('.arjo-m-mosaic-card__image-container');
      const buttonsContainer = card.querySelector('.arjo-m-mosaic-card__buttons');

      if (imageContainer && buttonsContainer) {
        const buttonEl = buttonsContainer.querySelector('.arjo-a-button');
        const linkEl = buttonsContainer.querySelector('.arjo-a-link');

        let target = imageContainer;

        if (card.classList.contains('arjo-m-mosaic-card--no-image')) {
          return;
        } else if (card.classList.contains('arjo-m-mosaic-card--background-image')) {
          target = card;
        }

        if (linkEl || buttonEl) {
          target.style.cursor = 'pointer';

          target.addEventListener('mousedown', (e) => {
            const { button, shiftKey, ctrlKey, altKey } = e;

            if (button !== 2 && !linkEl?.contains(e.target) && !buttonEl?.contains(e.target)) {
              linkEl && linkEl.dispatchEvent(new MouseEvent('mousedown'));
              buttonEl && buttonEl.dispatchEvent(new MouseEvent('mousedown'));
            }

            linkEl && linkEl.dispatchEvent(new MouseEvent('click', { button, shiftKey, ctrlKey, altKey }));
            buttonEl && buttonEl.dispatchEvent(new MouseEvent('click', { button, shiftKey, ctrlKey, altKey }));
          });
        }
      }
    });
  },
  init: function () {
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;

    addEventListener('resize', () => this.resizeHandler());
    this.setupLoadMore();
    this.setupLinkForImage();

    if ('ResizeObserver' in window) {
      // create an Observer instance
      const resizeObserver = new ResizeObserver(() => this.resizeHandler());

      // start observing a DOM node
      resizeObserver.observe(document.body);
    }
  },
};

window.addEventListener('load', function () {
  window.mosaicCardJs.init();
});

window.mosaicCardJs.resizeHandler();
